import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';

import { IsAssetPurchasedResponse, PurchasesProps, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';

import { queryKeys } from '../queryKeys';

export const useInvalidatePurchases = () => {
    const queryClient = useQueryClient();

    const invalidatePurchasesQuery = () => {
        queryClient.invalidateQueries({
            predicate: (query) => {
                const { queryKey } = query;
                if (typeof queryKey !== 'object' || !(queryKey instanceof Array)) return false;
                if (queryKey[0] === QUERY_KEYS.media && queryKey.includes('editions')) return true;
                return false;
            },
        });
        queryClient.invalidateQueries(queryKeys.myPurchases);
        queryClient.invalidateQueries(queryKeys.myRentals);
        queryClient.invalidateQueries(QUERY_KEYS.availableSubscriptions);
        queryClient.invalidateQueries(QUERY_KEYS.mySubscriptions);
        queryClient.invalidateQueries(QUERY_KEYS.blockers);
        queryClient.invalidateQueries(QUERY_KEYS.editions);
        queryClient.invalidateQueries(QUERY_KEYS.isPurchased);
        queryClient.invalidateQueries(QUERY_KEYS.entitledSubscriptions);
    };

    return { invalidatePurchasesQuery };
};

const useIsAssetPurchasedQuery = (
    asset: PurchasesProps,
    options?: UseQueryOptions<unknown, Error, IsAssetPurchasedResponse>
) => {
    const { fetchIsAssetPurchased } = usePurchaseData();

    return useQuery<unknown, Error, { isPurchased: boolean }>(
        queryKeys.isAssetPurchased(asset?.id),
        () => fetchIsAssetPurchased(asset),
        {
            enabled: Boolean(asset),
            ...options,
        }
    );
};

export default useIsAssetPurchasedQuery;
